module.exports = __webpack_public_path__ + "img/042.347898a5.png";